import { apiClient } from "./apiClient";

const CONTROLLER = "zendesk";

export const getToken = () => {
  const endpoint = CONTROLLER + "/token";
  return apiClient(endpoint).fetch();
};
